import { Collapse } from 'antd';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  header: ReactNode;
  keyProp: string;
}

const CollapsableFilter = ({ children, keyProp, header }: Props): JSX.Element => {
  return (
    <Collapse expandIconPlacement="end">
      <Collapse.Panel key={keyProp} header={header} forceRender={true}>
        {children}
      </Collapse.Panel>
    </Collapse>
  );
};
export default CollapsableFilter;
